import {MOCK_DATA} from "@/constants/mock/mock-data"
import {API_CONSTANTS} from "@/constants/api.constant"
import { inject } from 'vue'
import {addMocks, enableMocking} from "./mock-axios.util"
import { useSessionStore } from '@/stores/session'
import {delay} from "@/utils/index";
import {setLoadingState} from "@/utils/navigation.util";
// import API from "@/services/api";

if (process.env.VUE_APP_MOCK_ENABLED === 'true') {
    addMocks(MOCK_DATA);
    enableMocking(true);
}

// const HOST = 'http://localhost:8080'
const HOST = process.env.VUE_APP_API_BASE_URI
const HEADERS = {
    'Content-Type': 'application/json',
    // 'Access-Control-Allow-Origin': '*'
    // 'Access-Control-Allow-Headers': '*',
    // 'Access-Control-Expose-Headers': '*',
    // 'Access-Control-Allow-Credentials': true,
    // 'Upgrade-Insecure-Requests': 1,
    // 'withCredentials': 'true',
}

let axios = undefined

export default {
    getAbsPath() {
        return HOST+API_CONSTANTS.API_URI_PREFIX
    },
    isSuccess(response) {
        return response && Object.keys(response).length > 0
        // return response.status >= 200 && response.status < 300
    },
    async requestExternalUrl(method, url, params) {
        // inject axios if not done already
        if(! axios) {
            axios = inject('axios')  // inject axios
        }

        params = params || {};

        const obj = {method: method, url: url, data: params, headers: null}

        return axios(obj)
            .then((response) => {
                return response;
            }).catch((error) => {
                throw new Error(error);
                // return error;
            }).finally(() => {
                setLoadingState(false)
            });
    },
    async request(method, url, params = {}, headers = {}, responseType = 'json') {

        // inject axios if not done already
        if(! axios) {
            axios = inject('axios')  // inject axios
        }

        params = params || {};

        // add session parameters
        const session = useSessionStore();

        headers['sess_id'] = session.getSessionId || null

        if(! url.includes('http://') && ! url.includes('https://')) {
            url = HOST + url
        }

        headers = {...HEADERS, ...headers}
        const obj = {method: method, url: url, data: params, responseType: responseType, headers: headers}

        // debug: emulate delay
        if(process.env.VUE_APP_DELAY_PAGE_MS !== undefined && process.env.VUE_APP_DELAY_PAGE_MS !== 'false') {
            await delay(parseInt(process.env.VUE_APP_DELAY_PAGE_MS))
        }

        // quick dev:
        // await delay(3000);

        return axios(obj)
            .then((response) => {
                return response;
            }).catch((error) => {
                throw new Error(error);
                // return error;
            }).finally(() => {
                setLoadingState(false)
            });
    }

}